<template>
  <div class="home_content" id="tutorial0">
    <div class="home_share">
      <div class="hs_title">
        <img src="https://bucket-files-web3.oss-cn-hongkong.aliyuncs.com/community/home_title.png" class="hs_title__img" alt/>
      </div>
      <div class="hs_desc1">抓住Web3的机会&nbsp;&nbsp;|&nbsp;&nbsp;加入Web3学习之旅</div>
      <div class="hs_desc2">开源&nbsp;&nbsp;·&nbsp;&nbsp;免费&nbsp;&nbsp;·&nbsp;&nbsp;合作&nbsp;&nbsp;·&nbsp;&nbsp;共赢</div>
    
      <ul class="hs_share_ul">
        <li class="hs_share_li" v-for="(item, index) in shareList" :key="index">
          <img @click="handleShare(item)" :src="item.img" class="hs_share_li_img" alt @mouseleave="removeHoverStyle(index)"/>
          <div @click="handleShare(item)" class="hs_share_li_div" :id="'share'+index"></div>
        </li>
      </ul>
    </div>

    <div class="home_tutorial_timeline">
      <div class="home_tutorial">
        <tutorial
          :title="item.Name"
          :item="item"
          ref="timeLine"
          v-for="(item,index) in tutorialList"
          :key="index"
          :id="'tutorial'+(index+1)">
        </tutorial>
      </div>

      <div class="home_timeline">
        <time-line
          v-if="jobList.length>0"
          :title="'WEB3 求职招聘'"
          :item="jobList"
          :type="0"
          ref="timeLineJob"
          @click="getRecruit"
          style="margin: 77px 0 0 0;">
        </time-line>
        <div v-else 
          class="timeLineNoData" 
          style="margin: 77px 0 0 0;"
          v-loading="jobLoading"
          element-loading-text="加载中。。。">
        </div>

        <time-line
          v-if="infoList.length>0"
          :title="'WEB3 加密资讯'"
          :item="infoList"
          :type="1"
          ref="timeLineInfo"
          style="margin: 24px 0 0 0;">
        </time-line>
        <div v-else 
          class="timeLineNoData" 
          style="margin: 107px 0 0 0;"
          v-loading="infoLoading"
          element-loading-text="加载中。。。">
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import vueSeamlessScroll from 'vue-seamless-scroll'
import { getCategoryList, getJobList, getArticleRecommend, getRecommendList } from "@/config/api.js";
import {Carousel,CarouselItem,Loading } from 'element-ui'
import Vue from 'vue'
import TimeLine from '@/components/timeLine/timeLine.vue';
import Tutorial from '@/components/tutorial/tutorial.vue';
Vue.use(Carousel).use(CarouselItem).use(Loading)
export default {
  data() {
    return {
      jobList: [], // 招聘信息
      infoList: [], // WEB3 头条资讯
      tutorialList: [], // 教程
      thanksList: [], // 感谢列表
      currentIndex: 0,
      contributorImages: [],
      shareList: [
        {
          img: 'https://bucket-files-web3.oss-cn-hongkong.aliyuncs.com/community/share_1.png',
          url: "https://x.com/hita_dao"
        },
        {
          img: 'https://bucket-files-web3.oss-cn-hongkong.aliyuncs.com/community/share_2.png',
          url: "https://discord.gg/RTQzWkTF"
        },
        {
          img: 'https://bucket-files-web3.oss-cn-hongkong.aliyuncs.com/community/share_4.png',
          url: "https://t.me/+Wvs9ML0Ll9YxYjJl"
        },
        {
          img: 'https://bucket-files-web3.oss-cn-hongkong.aliyuncs.com/community/share_3.png',
          url: "https://github.com/hitadao"
        },
        // {
        //   img: 'https://bucket-files-web3.oss-cn-hongkong.aliyuncs.com/community/share_5.png',
        //   url: ""
        // },
      ], // 分享
      jobLoading: false, // 招聘信息 加载
      infoLoading: false, // WEB3 头条资讯 加载
    };
  },
  // mixins: [homeBase],
  components: {
    'time-line': TimeLine,
    'tutorial': Tutorial,
    vueSeamlessScroll
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      if(to.query.hasOwnProperty("tutorial")) {
        localStorage.setItem('tutorial',to.query.tutorial);
        vm.$router.replace({path: '/'}).then(() => {
          next();
        })
      }
      else {
        localStorage.setItem('tutorial','0');
      }
    });
  },

  beforeMount() {
    var that = this;
    that.jobLoading = true;
    that.infoLoading = true;
    that.requestGetJobList();
    that.requestGetArticleRecommend();
    that.requestGetCategoryList();
    that.requestGetRecommendList();
  },
  mounted() {
    for(var index=0; index<4;index++) {
      document.getElementById('share'+index).classList.remove('hs_share_li_div');
    }
  },
  methods: {
    scrollTutorial() {
      const tutorialId = localStorage.getItem('tutorial');
      document.getElementById('tutorial'+tutorialId).scrollIntoView();
    },
    // 总类列表
    requestGetCategoryList() {
      var that = this;
      getCategoryList({status: 1}).then((res) => {
        if (res.data) {
          that.tutorialList = res.data;
        }
      });
    },
    // 查询jobList
    requestGetJobList() {
      var that = this;
      getJobList().then((res) => {
        if (res.data) {
          that.jobList = res.data.data;
          that.jobLoading = false;
        }
      });
    },
    // 最新文章数据
    requestGetArticleRecommend() {
      var that = this;
      var param = { page: 1, type: 0, limit: 15 };
      getArticleRecommend(param).then((res) => {
        if (res.data) {
          that.infoList = res.data;
          that.infoLoading = false;
        }
      });
    },
    // 招聘信息页面
    getRecruit() {
      var that = this;
      that.$refs.timeLineJob.detail();
    },
    // 推荐查询
    requestGetRecommendList() {
      var that = this;
      getRecommendList().then((res) => {
        if (res.data) {
          that.bannerList = res.data.data
        }
      });
    },
    // 教程页面
    getTutorial(Slug) {
      var that = this;
      that.$router.push({
          path: "/tutorialDetail",
          query: { category: Slug }
      });
    },
    // 移出触发样式
    removeHoverStyle(index) {
      // 移除hover样式的逻辑
      document.getElementById('share'+index).classList.add('hs_share_li_div');
      setTimeout(() => {
        document.getElementById('share'+index).classList.remove('hs_share_li_div');
      }, 100); // 0.1秒后执行
    },
    // 分享
    handleShare(item) {
      if(item.url != "") {
        window.open(item.url, '_blank');
      }
    }
  },
  computed: {
    defaultOption () {
        return {
            step: 0.75, // 数值越大速度滚动越快
            limitMoveNum: 2, // 开始无缝滚动的数据量 this.dataList.length
            hoverStop: true, // 是否开启鼠标悬停stop
            direction: 2, // 0向下 1向上 2向左 3向右
            openWatch: true, // 开启数据实时监控刷新dom
            singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
            singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
            waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
        }
    }
  },
  watch: {
    tutorialList: function() {
      this.$nextTick(function(){
        this.scrollTutorial()
      })
    }
  }
};
</script>
<style lang="scss" scoped>
.home_content {
  width: 100%;
  min-height: 100vh;
  background: #F8F8F8;
  padding: 0 0 0 0;
  height: 100%;

  .home_share {
    width: 100%;
    height: 450px;
    background-image: url('https://bucket-files-web3.oss-cn-hongkong.aliyuncs.com/community/homebg.png');
    background-position: center;
    background-size: cover;

    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    .hs_title {
      width: 372px;
      height: 49px;
      margin: 74px 0 0 0;
      &__img{
        width: 372px;
        height: 49px;
        object-fit: contain;
      }
    }
    .hs_desc1 {
      font-weight: normal;
      font-size: 16px;
      color: #FFFFFF;
      line-height: 22px;
      text-align: center;
      font-style: normal;
      text-transform: none;

      margin: 17px 0 0 0;
    }
    .hs_desc2 {
      width: 276px;
      height: 50px;
      background: rgba(7,29,139,0.5);
      border-radius: 40px 40px 40px 40px;

      font-weight: normal;
      font-size: 18px;
      color: #FFFFFF;
      line-height: 50px;
      text-align: center;
      font-style: normal;
      text-transform: none;

      margin: 30px 0 0 0;
    }
    .hs_share_ul {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 62px 0 0 0;

      .hs_share_li {
        width: 47px;
        height: 46px;
        margin: 0 19px 0 19px;
        border-radius: 50%;

        .hs_share_li_img {
          width: 47px;
          height: 46px;
          object-fit: contain;
          cursor: pointer;
        }

        .hs_share_li_div {
          position: absolute;
          width: 47px;
          height: 46px;
          margin: -46px 0 0 0;
          border-radius: 50%;
          background-color: rgba(255,255,255,0.6);
        }
      }

      .hs_share_li:hover{
        box-shadow: 0px 0 8px 8px rgba(255,255,255,0.4);
        border-radius: 50%;
      }
    }
  }

  .home_tutorial_timeline {
    width: 83.4%;
    height: 100%;

    display: flex;
    padding: 0 8.3% 0 8.3%;


    .home_tutorial {
      width: calc(100% - 400px);
    }

    .home_timeline {
      margin: 0 0 0 24px;

      .timeLineNoData {
        width: 376px;
        height: 512px;
        background: #FFFFFF;
        border-radius: 8px 8px 8px 8px;
        border: 1px solid #ECECEC;
      }
    }
  }
}

@media screen and (max-width: 958px){ 
  .home_content {
    width: 100%;
    min-height: 100vh;
    background: #FAFAFA;
    padding: 0 0 0 0;

    .home_share {
      width: 100%;
      height: 317px;
      background-image: url('https://bucket-files-web3.oss-cn-hongkong.aliyuncs.com/community/homebg.png');
      background-position: center;
      background-size: cover;

      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;

      .hs_title {
        width: 316px;
        height: 42px;
        
        margin: 52px 0 0 0;
        &__img{
          width: 316px;
          height: 42px;
          object-fit: contain;
        }
      }
      .hs_desc1 {
        font-weight: normal;
        font-size: 16px;
        color: #FFFFFF;
        line-height: 22px;
        text-align: center;
        font-style: normal;
        text-transform: none;

        margin: 8.5px 0 0 0;
      }
      .hs_desc2 {
        width: 276px;
        height: 50px;
        background: rgba(7,29,139,0.5);
        border-radius: 40px 40px 40px 40px;

        font-weight: normal;
        font-size: 18px;
        color: #FFFFFF;
        line-height: 50px;
        text-align: center;
        font-style: normal;
        text-transform: none;

        margin: 15px 0 0 0;
      }
      .hs_share_ul {
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 22px 0 0 0;

        .hs_share_li {
          width: 47px;
          height: 46px;
          margin: 0 9.5px 0 9.5px;
          &__img {
            width: 47px;
            height: 46px;
            object-fit: contain;
            cursor: pointer;
          }
        }
      }
    }

    .home_tutorial_timeline {
      width: 91.7%;
      height: 100%;

      display: flex;
      padding: 0 4.15% 0 4.15%;

      .home_tutorial {
        width: calc(100%);
      }

      .home_timeline {
        display: none;
      }
    }
  }
}
</style>